import * as React from 'react';
import * as styles from './Discount.css';
import { IconHotLeads16, UIText3 } from '@cian/ui-kit';
import { NBSP } from '../../../../../../../../constants/symbols';
type TDiscountProps = {
  isPromoDiscount: boolean;
  discount: number;
  disabled?: boolean;
};
export const Discount: React.FC<TDiscountProps> = ({ disabled, discount, isPromoDiscount }) => {
  if (!discount) {
    return null;
  }

  return (
    <div className={styles['wrapper']}>
      {isPromoDiscount ? (
        <div className={styles['promo-discount']}>
          <UIText3 color="warning_100">-{discount}%</UIText3>
          <IconHotLeads16 color="warning_100" />
        </div>
      ) : (
        <UIText3 color={disabled ? 'gray40_100' : 'primary_100'}>
          Скидка{NBSP}
          {discount}%
        </UIText3>
      )}
    </div>
  );
};
